import tokens from './tokens'
import { FarmConfig } from './types'

const farms: FarmConfig[] = [
  /**
   * These 3 farms (PID 0, 251, 252) should always be at the top of the file.
   */
  {
    pid: 0,
    lpSymbol: 'SantaMax',
    lpAddresses: {
      97: '0x06D451D83bbb3d0685dAf97dFb7bA8d70FF77bfA',
      56: '0x06D451D83bbb3d0685dAf97dFb7bA8d70FF77bfA',
    },
    token: tokens.syrup,
    quoteToken: tokens.busd,
  },
  {
    pid: 1,
    lpSymbol: 'SantaMax-BNB LP',
    lpAddresses: {
      97: '0xd93fbE06cCC436640180BF4c18Cb11d8fE8F1324',
      56: '0xd93fbE06cCC436640180BF4c18Cb11d8fE8F1324',
    },
    token: tokens.cake,
    quoteToken: tokens.wbnb,
  },
  {
    pid: 2,
    lpSymbol: 'SantaMax-BUSD LP',
    lpAddresses: {
      97: '0x35dD9c6B4bBe177522F24Fd8608CDF7DDe0B7fD0',
      56: '0x35dD9c6B4bBe177522F24Fd8608CDF7DDe0B7fD0',
    },
    token: tokens.cake,
    quoteToken: tokens.busd,
  },
  
  
   //* V3 by order of release (some may be out of PID order due to multiplier boost)

  {
    pid: 443,
    lpSymbol: 'SantaMax-USDT LP',
    lpAddresses: {
      97: '',
      56: '0x79b05d913cbb1353fbe46cd9079d7c61ab3d04d4',
    },
    token: tokens.cake,
    quoteToken: tokens.usdt,
  },
  {
    pid: 442,
    lpSymbol: 'SantaMax-ETH LP',
    lpAddresses: {
      97: '',
      56: '0xb5d108578be3750209d1b3a8f45ffee8c5a75146',
    },
    token: tokens.cake,
    quoteToken: tokens.eth,
  }, 
 
]

export default farms
